import authService from "authService"
import { useEffect } from "react"
import useLogAction from "./useLogAction"

const useLogNavigation = (page) => {
  const { logPageView } = useLogAction()

  useEffect(() => {
    if (!authService.state.displayed) {
      logPageView({ page })
      authService.setDisplayed(true)
    }
  }, [])
}

export default useLogNavigation